export function extractMonthsInRange(startDate, endDate) {
    const startYear = startDate?.getFullYear();
    const endYear = endDate?.getFullYear();
    const startMonth = startDate?.getMonth();
    const endMonth = endDate?.getMonth();
    
    const months = [];
    
    for (let year = startYear; year <= endYear; year++) {
        const monthStart = (year === startYear) ? startMonth : 0;
        const monthEnd = (year === endYear) ? endMonth : 11;
        
        for (let month = monthStart; month <= monthEnd; month++) {
            months.push(`${(month + 1).toString().padStart(2, '0')}-${year}`);
        }
    }
    
    return months;
}